import { render, staticRenderFns } from "./CategoryStepSequences.vue?vue&type=template&id=3967622d&scoped=true&"
import script from "./CategoryStepSequences.vue?vue&type=script&lang=js&"
export * from "./CategoryStepSequences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3967622d",
  null
  
)

export default component.exports